export default function _updateContentMetaIndex (contentMetaIndex) {
  if (Object.keys(contentMetaIndex).length === 0) {
    return {type: 'NOOP'};
  }
  return {
    type: 'UPDATE_CONTENT_META_INDEX',
    payload: contentMetaIndex,
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_updateContentMetaIndex.js